module.exports = __webpack_public_path__ + "img/bg08.61319ce7.gif";